import React from 'react'

import { Icon } from '@driftt/dds'
import { faCircleInfo } from '@driftt/dds.icons/regular/faCircleInfo'
import { faFilter } from '@driftt/dds.icons/regular/faFilter'
import { faMagnifyingGlass } from '@driftt/dds.icons/regular/faMagnifyingGlass'
import { ActionDropdown, Colorway, H4, Input, ToolTip } from '@driftt/tide-core'

import { useRTDContext } from 'layouts/RealTimeDashboard/Overview/context'
import { trackEvent } from 'utils/tracking'

import styles from './styles.module.css'

export const EmptyTablePlaceholder: React.FC<{ text: string }> = ({ text }) => (
  <div className={styles.emptyContainer}>
    <Colorway type="4">
      <Icon icon={faMagnifyingGlass} />
    </Colorway>
    <H4>{text}</H4>
  </div>
)

export const FilterTableHeader: React.FC<{
  text: string
  actions: any[]
  handleFilter: (string) => void
  activeFilter: Record<string, boolean>
  dataOcWebId?: string
}> = ({ text, actions, handleFilter, activeFilter, dataOcWebId }) => {
  const context = useRTDContext()

  return (
    <span>
      {text}
      <ActionDropdown
        trigger={
          <div data-ocweb-id={dataOcWebId}>
            <Icon icon={faFilter} />
            {Object.values(activeFilter).some((v) => v) && (
              <div className={styles.activeFilterBadge} />
            )}
          </div>
        }
        actions={actions.map((actionName) => ({
          label: (
            <Input
              type="checkbox"
              label={`${actionName.charAt(0).toUpperCase()}${actionName.slice(
                1
              )}`}
              checked={activeFilter[actionName]}
            />
          ),
          action: () => {
            trackEvent('RTDBehavior', {
              event: 'Table Header Filter',
              widget: 'RTDTeammatePerfTable',
              filterType: actionName,
              view: context.isSalesView ? 'sales' : 'service',
            })
            handleFilter(actionName)
          },
        }))}
        className={styles.filterDropdown}
      />
    </span>
  )
}

export const withSimpleInfoTooltip = (text, tooltip) => (
  <span>
    {text}
    <ToolTip flow="up" render={() => tooltip} className={styles.tooltipWrapper}>
      <Icon icon={faCircleInfo} />
    </ToolTip>
  </span>
)

export const DDSTooltip: React.FC<{
  label: React.ReactNode
  content: React.ReactNode
}> = ({ label, content }) => (
  <ToolTip
    flow="down"
    className={styles.ddsTooltip}
    render={() => <div>{content}</div>}
  >
    <span>{label}</span>
  </ToolTip>
)
